import React from 'react';
import styled from "styled-components";
import { BrowserRouter as Router, Route, Link, withRouter } from "react-router-dom";
import SVGIcon from './SVGIcon.js'
import logo from '../img/sidebar/CINJ.svg';

//TODO: Create responsive navbar

/*
* SideNav styling 
*/
const StyledSideNav = styled.div`
    display: flex; 
    flex-direction: column;
    justify-content: flex-start;
    position: fixed;
    height: 100%; 
    width: 212px;
    z-index: 1; 
    background-color: #F5F5F7; 
    overflow-x: hidden;
    @media (max-width: 900px){
        display: none; 
    }
    @media (max-height: 540px){
        display: none; 
    }
`;

const NavIcon = styled.div`
    margin: 0px; 
`;

const StyledNavBrand = styled.div`
    font-size: 1.4em;
    color: #9FFFCB;
    &:hover { color: white; }
    width: 135px; 
    margin-left: auto; 
    margin-right: auto; 
    margin: 24px 0px 24px 24px; 
`;

const StyledNavItem = styled.div`
    display: flex; 
    flex-direction: row;
    height: 56px; 
    width: 212px; /*width must be same size as Navbar to center*/
    // padding: 12px 0px;
    align-items: left;
    text-align: left;
    background-color: ${
        props => props.active ?
            "#FAFAFA" :
            "transparent"
    };
    color: ${
        props => props.active ?
            "#1D1D1F" :
            "#86868B"
    };
    :hover {
            background-color: #FAFAFA;
            h4{
                color: #1D1D1F;
            }
        }
    div{
        display: flex; 
        position: relative;
        justify-content: center;
    }
    a{
        display: flex; 
        flex-direction: row;
        align-self: center;
        // :hover {
        //     opacity: 0.7; 
        //     text-decoration: none;
        // }
        color: inherit;
        text-decoration:none;
        margin-left: 24px; 
        padding: 16px 0px; 
    }
    h4{
        text-align: center;
        margin: 0 auto; 
        color: inherit;
        margin-left: 16px; 
    }
`;

const StyledIndicator = styled.div`
    position: absolute; 
    width: 6px;
    height: 100%; 
    background-color: ${
        props => props.active ?
            "#66666A;" :
            "transparent"
    };
`

class NavItem extends React.Component{
    handleClick = () => {
        //need these to be passed in as props
        const { path, onItemClick } = this.props;
        onItemClick(path);
    }

    render(){
        const { active } = this.props;
        return (
            <StyledNavItem active = {active}>
                <div>
                    <StyledIndicator active = {active}></StyledIndicator>
                    <Link to={this.props.path} onClick = {this.handleClick}>
                        <NavIcon><SVGIcon name={this.props.name} width={28} active={active}></SVGIcon></NavIcon>
                        <h4>{this.props.name}</h4>
                    </Link>
                </div>
            </StyledNavItem>
        );
    }
}

class SideNav extends React.Component {
    constructor(props){
        super(props); 
        this.state = {
            activePath: props.location.pathname,
            items: [
                {
                    path: '/' /*used as id to check which navitem is active*/,
                    name: 'Home',
                    img: require( '../img/sidebar/Home-Active.svg'),
                    key: 1,
                },
                {
                    path: '/about',
                    name: 'About',
                    img: require( '../img/sidebar/About.svg'),
                    key: 2
                },
                {
                    path: '/first100days',
                    name: 'First 100 Days',
                    img: require( '../img/sidebar/Calendar.svg'),
                    key: 3
                },
                {
                    path: '/care',
                    name: 'Care',
                    img: require( '../img/sidebar/Care.svg'),
                    key: 4
                },
                {
                    path: '/prognosis',
                    name: 'Prognosis',
                    img: require( '../img/sidebar/Prognosis-Active.svg'),
                    key: 5
                },
                {
                    path: '/profile',
                    name: 'Profile',
                    img: require( '../img/sidebar/Profile.svg'),
                    key: 6
                },
                // {
                //     path: '/NoMatch',
                //     name: 'NoMatch',
                //     img: require( '../img/Profile.svg'),
                //     key: 7
                // },
            ]
        }
    }

    onItemClick = (path) => {
        /*change the activePath by setting the state*/
        this.setState ({activePath: path}); /*Sets activePath causing rerender causing CSS to change*/
    }

    render() {
        //retrieve items and activePath from the state
        const { items, activePath } = this.state;

        //then render all items by looping through with map()
        return (
            <StyledSideNav>
                <StyledNavBrand href="/"><a href="/"><img src={logo}/></a></StyledNavBrand>
                {
                    items.map((item) => {
                        /*Return NavItems*/
                        return (
                            <NavItem path = {item.path} name={item.name} 
                            onItemClick={this.onItemClick} active={item.path === activePath} 
                            key={item.key} img={item.img}> </NavItem>
                        )
                    })
                }
            </StyledSideNav>
        );
      }
}

const RouterSideNav = withRouter(SideNav); 

export default class Sidebar extends React.Component {
  render() {
    return (
        <RouterSideNav></RouterSideNav>

    );
  }
}